/* eslint-disable no-unused-vars */
const routeMixin = {
  computed: {
    getRouteMeta() {
      return this.$route.meta;
    },
    currentRouteName() {
      return this.$route.name.toLowerCase();
    },
    currentRoute() {
      return this.$route.params.routeName;
    },
    currentRouteUser() {
      return this.$route.params.routeName === 'user';
    },
    currentApplicationName() {
      return this.$route.params.applicationName;
    },
    currentSubRoute() {
      return this.$route.params.subRouteName;
    },
    currentActiveId() {
      return this.$route.params.id;
    },
    currentActivePId() {
      return this.$route.params.pid;
    },
    currentActionRoute() {
      return this.$route.params.action;
    },
    isAddActive() {
      return this.$route.params.id === 'new' || this.$route.params.pid === 'add';
    },
    currentActionRouteView() {
      return this.$route.params.action === 'view';
    },
    currentActionRouteSearch() {
      return this.currentActionRoute === 'search';
    },
    getProductType() {
      return this.$route.params.productType || '';
    },
    getProductCode() {
      return this.$route.params.productCode || '';
    },
    getProductTerm() {
      return this.$route.params.productTerm || '';
    },
  },
};
export default routeMixin;
